import Api from '@/api'
import router from '@/router'

class LocationManager {
  previousLocations: string[] = []

  public install (Vue: any) {
    Vue.prototype.$locationManager = this

    const savedLocations = sessionStorage.getItem('location-manager:locations')
    if (savedLocations) {
      this.previousLocations = savedLocations.split('~~~')
    }
  }

  getToken () {
    return Api.getToken()
  }

  rememberLocation (location: string) {
    this.previousLocations.push(location)
    this.saveLocations()
  }

  rememberAndGoTo (location: string | object) {
    this.rememberLocation(window.location.pathname + window.location.search)
    return router.push(location)
  }

  saveLocations () {
    sessionStorage.setItem('location-manager:locations', this.previousLocations.join('~~~'))
  }

  goBack (defaultLocation: any) {
    const location = this.previousLocations.pop()
    this.saveLocations()

    if (!router) {
      throw new Error('LocationManager: Router is not initialized')
    }

    router.push(location || defaultLocation)
  }

  openNewTab (url: string, focus: boolean = false) {
    if (/\?token|&token/gm.test(url)) {
      if (focus) {
        // @ts-ignore
        window.open(url, '_blank').focus()
        return
      }
      window.open(url, '_blank')
      return
    }

    if (focus) {
      // @ts-ignore
      window.open(`${url}${url.indexOf('?') === -1 ? '?' : '&'}token=${this.getToken()}`, '_blank').focus()
      return
    }

    window.open(`${url}${url.indexOf('?') === -1 ? '?' : '&'}token=${this.getToken()}`, '_blank')
  }
}

const locationManager = new LocationManager()

export default locationManager
